import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTriggerAlt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.59835 9.34835C6.06282 7.88388 8.43718 7.88388 9.90165 9.34835C10.1945 9.64124 10.6694 9.64124 10.9623 9.34835C11.2552 9.05546 11.2552 8.58058 10.9623 8.28769C8.91206 6.23744 5.58794 6.23744 3.53769 8.28769C1.48744 10.3379 1.48744 13.6621 3.53769 15.7123C5.58794 17.7626 8.91206 17.7626 10.9623 15.7123C11.2552 15.4194 11.2552 14.9445 10.9623 14.6517C10.6694 14.3588 10.1945 14.3588 9.90165 14.6517C8.43718 16.1161 6.06282 16.1161 4.59835 14.6517C3.13388 13.1872 3.13388 10.8128 4.59835 9.34835Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21.9989 12C21.9989 11.8909 21.9756 11.7871 21.9338 11.6936L21.8112 11.5033C21.8009 11.4916 21.7901 11.4801 21.7789 11.4689L17.53 7.22C17.2367 6.92667 16.7611 6.92667 16.4678 7.21999C16.1745 7.51332 16.1745 7.98889 16.4678 8.28222L19.4345 11.2489L8.00111 11.2489C7.58628 11.2489 7.25 11.5852 7.25 12C7.25 12.4148 7.58628 12.7511 8.00111 12.7511H19.4345L16.4678 15.7178C16.1745 16.0111 16.1745 16.4867 16.4678 16.78C16.7611 17.0733 17.2367 17.0733 17.53 16.78L21.7789 12.5311L21.7805 12.5295C21.8497 12.4599 21.9024 12.3802 21.9387 12.2951C21.9775 12.2045 21.9989 12.1048 21.9989 12Z",
		fill: "currentColor"
	})]
});
export { SvgIconTriggerAlt as ReactComponent };
